<template>
    <teleport to="body">
        <transition leave-active-class="duration-200">
            <div v-show="props.show" class="modal-wrapper" :class="{ 'modal-wrapper--fullscreen': props.fullscreen }" scroll-region>
                <transition
                    enter-active-class="duration-300 ease-out"
                    enter-from-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="duration-200 ease-in"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0"
                >
                    <div v-show="props.show && !props.fullscreen" class="modal-backdrop" @click="close">
                        <div class="modal-overlay"></div>
                    </div>
                </transition>

                <transition
                    enter-active-class="duration-300 ease-out"
                    :enter-from-class="props.fullscreen ? 'opacity-0' : 'translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95'"
                    :enter-to-class="props.fullscreen ? 'opacity-100' : 'translate-y-0 opacity-100 sm:scale-100'"
                    leave-active-class="duration-200 ease-in"
                    :leave-from-class="props.fullscreen ? 'opacity-100' : 'translate-y-0 opacity-100 sm:scale-100'"
                    :leave-to-class="props.fullscreen ? 'opacity-0' : 'translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95'"
                >
                    <div v-show="props.show" class="modal-content" v-bind="$attrs" :class="props.fullscreen ? 'modal-content--fullscreen' : maxWidthClass">
                        <slot v-if="props.show"></slot>
                    </div>
                </transition>
            </div>
        </transition>
    </teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { onKeyStroke } from '@vueuse/core';

defineOptions({
    inheritAttrs: false,
});

const props = defineProps({
    maxWidth: {
        type: String,
        default: '2xl',
    },

    show: {
        type: Boolean,
        default: false,
    },

    fullscreen: {
        type: Boolean,
        default: false,
    },

    closeable: {
        type: Boolean,
        default: true,
    },

    closeOnEscape: {
        type: Boolean,
        default: true,
    },
});

const emit = defineEmits<{
    (event: 'close'): void;
}>();

const close = () => {
    if (props.closeable) {
        emit('close');
    }
};

const maxWidthClass = computed(() => {
    return {
        sm: 'modal-content--sm',
        md: 'modal-content--md',
        lg: 'modal-content--lg',
        xl: 'modal-content--xl',
        '2xl': 'modal-content--2xl',
        '3xl': 'modal-content--3xl',
        '4xl': 'modal-content--4xl',
        '5xl': 'modal-content--5xl',
        '6xl': 'modal-content--6xl',
        '7xl': 'modal-content--7xl',
    }[props.maxWidth];
});

onKeyStroke('Escape', props.closeOnEscape && props.closeable ? close : undefined);
</script>
